import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getPaths } from '../../utils/element';
export const storesApi = createApi({
    reducerPath: 'storesApi',
    baseQuery: fetchBaseQuery({ baseUrl: getPaths().app_ajax_store_locator_pins }),
    endpoints: builder => ({
        getStores: builder.query({
            query: () => '',
        }),
    }),
});
export const { useGetStoresQuery } = storesApi;
